module.exports = __webpack_public_path__ + "img/youtube.a7445e52.svg";